import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { LoadingSpinner, AccessibilityWrapper } from 'legacy-packages/ft-cb';
import { withApollo } from 'react-apollo';
import Button from 'chameleon/ui-stack/ui/base/button';
import SingleAction from 'chameleon/ui-stack/ui/assessments/actions/single-action';
import PopOver from 'chameleon/ui-stack/ui/base/popover';
import log from 'chameleon/ui-stack/utilities/log';
import './index.scss';

class DownloadPDFButton extends Component {
  static propTypes = {
    className: PropTypes.string,
    variables: PropTypes.object,
    getURLFromResponse: PropTypes.func,
    downloadFreshCopy: PropTypes.bool,
    onDownload: PropTypes.func,
    label: PropTypes.any,
    onSendTelemetryEvent: PropTypes.func,
  };

  static defaultProps = {
    downloadFreshCopy: false,
    onDownload: () => {},
    onSendTelemetryEvent: () => {},
    label: '',
    btnClassName: '',
  };

  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      url: null,
    };

    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    const { url } = this.state;
    const { downloadFreshCopy, onDownload, onSendTelemetryEvent } = this.props;
    onSendTelemetryEvent && onSendTelemetryEvent();

    if (url && !downloadFreshCopy) {
      download(url);
      onDownload(downloadFreshCopy);
    } else {
      const { query, variables, getURLFromResponse } = this.props;
      this.setState(
        {
          loading: true,
        },
        () => {
          this.props.client
            .query({
              query,
              fetchPolicy: 'network-only',
              variables,
            })
            .then((resp) => {
              const urlFromResponse = getURLFromResponse(resp);
              this.setState({
                loading: false,
                url: urlFromResponse,
              });
              download(urlFromResponse);
              onDownload(downloadFreshCopy);
            })
            .catch((error) => {
              this.setState({
                loading: false,
              });
              log('error', error);
            });
        },
      );
    }
  }

  render() {
    const {
      children,
      className,
      showIcons = false,
      label,
      role,
      btnClassName,
    } = this.props;
    const { loading } = this.state;

    /**
     * Only show loader if parent is ready to start
     * */
    return (
      <div className={className}>
        <div className="pdf-loader-popover__container">
          {loading && loadingPopover({ showIcons })}
          {(showIcons && (
            <AccessibilityWrapper>
              <SingleAction
                role={role}
                disabled={loading}
                onClick={this.onClick}
                tabIndex={0}
                className={btnClassName}
                isDefault={false}
                iconName="scoring_guideline"
                iconWidth="16"
                iconHeight="16"
                title="Scoring Guide"
                ariaLabel="Scoring Guide"
              >
                {label}
              </SingleAction>
            </AccessibilityWrapper>
          )) || (
            <Button
              isSecondary
              tabIndex={0}
              disabled={loading}
              onClick={this.onClick}
            >
              {children}
            </Button>
          )}
        </div>
      </div>
    );
  }
}

export const LoadingLabel = () => (
  <div id="PdfLoaderWrap">
    <span className="vanishing_text">
      <LoadingSpinner />
      <div
        aria-live="assertive"
        aria-label="This may take up to 30 seconds"
        className="text"
      >
        This may take up to 30 seconds.
      </div>
    </span>
  </div>
);

export const loadingPopover = ({ showIcons }) => {
  return (
    <PopOver
      withPortal
      className={`pdf-loader-popover ${showIcons && 'icons-popover'}`}
      defaultOpen
      trigger={<LoadingLabel />}
    />
  );
};

const download = (url) => {
  window.location.href = url;
};

export default withApollo(DownloadPDFButton);
